import React from 'react';
import styles from './RegistrationInput.module.scss';

interface RegistrationInputProps {
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  autoComplete?: string;
  className?: string;
  rightIcon?: React.ReactNode;
  onRightIconClick?: () => void;
}

const RegistrationInput: React.FC<RegistrationInputProps> = ({
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  disabled = false,
  autoComplete,
  className = "",
  rightIcon,
  onRightIconClick,
}) => {
  return (
    <div className={`${styles.inputContainer} ${className}`}>
      <div className={styles.inputWrapper}>
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          autoComplete={autoComplete}
          className={`${styles.input} ${error ? styles.inputError : ''} ${rightIcon ? styles.inputWithIcon : ''}`}
        />
        {rightIcon && (
          <button
            type="button"
            className={styles.rightIconButton}
            onClick={onRightIconClick}
            disabled={disabled}
            aria-label="Toggle visibility"
          >
            {rightIcon}
          </button>
        )}
      </div>
      {error && (
        <div className={styles.errorMessage}>
          {error}
        </div>
      )}
    </div>
  );
};

export default RegistrationInput;
